// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"42":"25c625140e1884d29d10","260":"90afa6fda7b3878f2fb6","702":"e076231cdafad3704f4d","715":"e94a9726a3d8afb6cb2b"}[chunkId] + ".css";
};